import { Query } from '@jupiterone/jupiter-types/question';
import { createStyles, Tooltip, Typography } from '@material-ui/core';
import { WithStyles, withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../..';

const styles = (theme: JupiterTheme) =>
  createStyles({
    content: {
      fontFamily: `'Ubuntu Mono', monospace`,
      maxWidth: '100%',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 'lighter',
      color: theme.palette.common.white,
      fontSize: '12px',
    },
    selected: {
      color: theme.palette.primary.main,
    },
    tooltip: {
      whiteSpace: 'pre-line',
    },
  });

interface Props extends WithStyles<typeof styles> {
  query: Query;
  selected: boolean;
  index: number;
}

export const QueryTab = ({ query, selected, index, classes }: Props) => {
  return (
    <Tooltip title={<div className={classes.tooltip}>{query.query}</div>}>
      <Typography
        variant="body1"
        className={clsx(classes.content, selected && classes.selected)}
      >
        {query.name || `Query ${index}`}
      </Typography>
    </Tooltip>
  );
};

export default withStyles(styles)(QueryTab);
